import React from 'react'
import './school-users-signup-layout.scss'
import { Constants, ImageConstants } from '../../constants/constants'
import { getImageSource } from '../../utility/image-source'
import Loading from '../common/loading/loading'
import Path from '../routes/routes-path'
import MasterDataApi from '../../apis/master-data'
import SchoolApi from '../../apis/school'
import CommonApi from '../../apis/common'
import SignupSuccess from './sign-up-success/sign-up-success'
import SchoolUserSignUp from './sign-up/sign-up'
import SchoolUserApi from '../../apis/student'

class SchoolUsersSignupLayout extends React.Component {
  state = {
    activeTabIndex: 1,
    classDropdownData: null,
    sectionDropdownData: null,
    boardDropdownData: null,
    staffTypesDropdown: null,
    isSignUpfailed: false,
    isEmailAlreadyRegistered: false,
    isLoginFailed: false,
    loading: false,
    signUpEmail: null,
    isSignupSuccess: false,
    name: '',
  }

  countryCodeHash = {}

  tabs = [{ name: 'Signup' }]
  constructor(props) {
    super(props)
    this.state.userId = this.getParameterByName(
      'user',
      this.props?.location?.search
    )
  }

  componentDidMount() {
    this.getStaffTypesDetails()
    this.getCountryCodes()
    this.getStaffSchoolData()
  }

  /**
   * Get respective params from the provided URL
   * @param {*} name - Param name
   * @param {*} url - Provided URL
   */
   getParameterByName = (name, url) => {
    if (url) {
      name = name.replace(/[\[\]]/g, '\\$&')
      var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)'),
        results = regex.exec(url)
      if (!results) return null
      if (!results[2]) return ''
      return decodeURIComponent(results[2].replace(/\+/g, ' '))
    }

    return ''
  }

  getStaffSchoolData = () => {
    const {userId} = this.state
    const payload = {
      userId
    }
    SchoolUserApi.getStaffAndSchoolDetails(payload).then(staff=>{
      this.setState({
        userDetails: staff
      }, _ => {
        this.getClassAndBoard()
      })
    }).catch(err => {
        this.setState({
          boardDropdownLoading: false
        })
      })
  }

  onCountryCodeSearch(value, index) {
    if (value.length > 2 || !value) {
      this.countryCodeIndex = index
      this.getCountryCodes({ name: `/${value}` })
    }
  }

  getClassAndBoard(payload = {}) {
    const {userDetails} = this.state
    payload.schoolId = userDetails.schoolCode
    SchoolApi.getClassAndBoardPublic(payload)
        .then(school => {
            let classes = [], boards = [];
            for (let i = 0; i < school.classes.length; i++) {
                classes.push({
                    title: school.classes[i].name,
                    value: school.classes[i].name,
                })
            }

            for (let i = 0; i < school.boards.length; i++) {
                boards.push({
                    title: school.boards[i].name,
                    value: school.boards[i].name,
                })
            }

            let board = this.state.board
            if (!board && boards.length == 1) {
                board = boards[0].value
            }


            this.setState({ board, classDropdownData: classes, boardDropdownData: boards })
        }).catch(err => {
        })
}

  getStaffTypesDetails() {
    let payload = { limit: 100 }
    payload.types = "in/MATH_HOD,PRINCIPAL,VICE_PRINCIPAL"
    SchoolApi.getAllStaffTypes(payload)
      .then(staffTypes => {
        let items = []
        for (let i = 0; i < staffTypes.response.length; i++) {
          items.push({
            title: staffTypes.response[i].displayType,
            value: staffTypes.response[i].type
          })
        }
        this.setState({ staffTypesDropdown: items })
      })
      .catch(err => { })
  }

  getCountryCodes(payload = {}) {
    CommonApi.getCountryCodeList(payload)
      .then(response => {
        let data = response.response
        if (data.length) {
          this.setState({ countryList: data })
          let countryCodeDropdown = this.buildCountryCodeDropdown(data)
          this.setState({ countryCodeDropdown })
        }
      })
      .catch(err => { })
  }

  buildCountryCodeDropdown(list = []) {
    let countryCodeDropdown = []
    let localHash = {}
    for (let i = 0; i < list.length; i++) {
      let item = list[i]

      if (!localHash[item.dialCode]) {
        this.countryCodeHash[item.dialCode] = item
        localHash[item.dialCode] = item
        countryCodeDropdown.push({
          title: `${item.name} ${item.dialCode}`,
          addOn: item.name,
          value: item.dialCode
        })
      }
    }
    this.setState({ hashedCountryCode: this.countryCodeHash })
    return countryCodeDropdown
  }

  goToMenu() {
    this.props.history.replace(Path.DASHBOARD)
  }

  setSignupSuccess = name => {
    this.setState({
      isSignupSuccess: true,
      name: name
    })
  }

  render() {
    const { isSignupSuccess, name, userDetails } = this.state
    return (
      <>
        {this.state.loading && <Loading />}
        <div className='container-fluid school-users-signup-layout'>
          <div className='header row no-gutters'>
            <div className='col-6'>
              <a href='https://countingwell.com'>
                <img
                  alt=''
                  className='logo'
                  src={getImageSource(ImageConstants.CW_LOGO)}
                />
              </a>
            </div>
          </div>

          <div className='row'>
            <div className='col-7 signup-container'>
              {!isSignupSuccess && (
                <>
                  <div className='row maths-day-container'>
                    <div class='maths-day-description'>
                      <p className='slogan-text-signup'>
                        Hey!
                      </p>
                      <p>
                        <strong>{userDetails?.schoolName}</strong> has initiated the Countingwell Maths Program for its students. Please sign up to join the Countingwell Maths Homework portal and start assigning homework and reviewing performance of your students.
                      </p>
                      <p>
                        Countingwell makes Maths learning fun with step-by-step personlized learning path.
                      </p>
                    </div>
                    <div className='video-banner'>
                      <img
                          alt=''
                          className='video-banner-img'
                          src={getImageSource(
                            ImageConstants.VIDEO_BANNER
                          )}
                        />
                    </div>
                  </div>
                  <ul className='row'>
                    <li className='col-4 highlights'>
                      <div className='details'>
                        <img
                          alt=''
                          className='icon'
                          src={getImageSource(
                            ImageConstants.PEOPLE
                          )}
                        />
                      </div>
                      <p className='title'>10000+</p>
                      <p className='text-center'>
                      Active Students
                      </p>
                    </li>
                    <li className='col-4 highlights'>
                      <div className='details'>
                        <img
                          alt=''
                          className='icon'
                          src={getImageSource(ImageConstants.PLAY_RED)}
                        />
                      </div>
                      <p className='title'>800+</p>
                      <p className='text-center'>
                      Learning Videos
                      </p>
                    </li>
                    <li className='col-4 highlights'>
                      <div className='details'>
                        <img
                          alt=''
                          className='icon'
                          src={getImageSource(ImageConstants.NOTES)}
                        />
                      </div>
                      <p className='title'>1000+</p>
                      <p className='text-center'>
                      Practice Questions
                      </p>
                    </li>
                  </ul>
                  <div className='testimonials'>
                    <p>I am enjoying the app. Beside I am also learning. Now I am thinking if countingwell app was not there I would be bored.</p>
                    <p><strong>Bidhyanshu Das, Class 7 Student from Kolkata</strong></p>
                  </div>
                </>
              )}
              {isSignupSuccess && <SignupSuccess name={name} />}
            </div>
            <div className='col-5'>
              <div className='row center-box p-2'>
                {this.state.activeTabIndex == Constants.ACTIVE_TAB_SIGN_UP &&
                  this.state.userDetails &&
                  this.state.boardDropdownData &&
                  this.state.staffTypesDropdown &&
                  this.state.countryCodeDropdown &&
                  this.state.classDropdownData && (
                    <SchoolUserSignUp
                      classes={this.state.classDropdownData}
                      boards={this.state.boardDropdownData}
                      countries={this.state.countryCodeDropdown}
                      roles={this.state.staffTypesDropdown}
                      userDetails={this.state.userDetails}
                      hashedCountryCode={this.state.hashedCountryCode}
                      isSignUpfailed={this.state.isSignUpfailed}
                      isEmailAlreadyRegistered={
                        this.state.isEmailAlreadyRegistered
                      }
                      delegate={this}
                      setSignupSuccess={this.setSignupSuccess}
                      {...this.props}
                    ></SchoolUserSignUp>
                  )}
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }
}

export default SchoolUsersSignupLayout
